import { CloseIcon } from '../../../assets/icons';

type CloseButtonProps = {
  onClose: VoidFunction;
  ariaLabel?: string;
};

export const CloseButton = ({ onClose, ariaLabel = 'Close' }: CloseButtonProps) => {
  return (
    <button type="button" aria-label={ariaLabel} onClick={onClose} className="core-close-button__button">
      <CloseIcon width="1rem" height="1rem" opacity={0.7} />
    </button>
  );
};
